export const Types = {
  TOGGLE: '@loading/TOGGLE',
};

export function toggleLoading(status) {
  return {
    type: Types.TOGGLE,
    payload: status,
  };
}
